import { SVGProps, Ref, forwardRef } from 'react';

export const LoaderOutlinedSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 5.6A18.4 18.4 0 1 0 42.4 24H46A22 22 0 1 1 24 2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LoaderOutlinedSize48Glyph.displayName = 'LoaderOutlinedSize48Glyph';
